/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SimpleContentResponseDto = {
  /**
   * 이미지 URL (COUPANG_IFRAME이면 쿠팡 위젯 URL)
   */
  imageUrl: string;
  /**
   * 미디어 타입 (전환 광고: IMAGE/COUPANG_IFRAME, 미지정=IMAGE)
   */
  mediaType?: SimpleContentResponseDto.mediaType;
  /**
   * 랜딩 URL
   */
  landingUrl?: string;
};
export namespace SimpleContentResponseDto {
  /**
   * 미디어 타입 (전환 광고: IMAGE/COUPANG_IFRAME, 미지정=IMAGE)
   */
  export enum mediaType {
    IMAGE = "IMAGE",
    COUPANG_IFRAME = "COUPANG_IFRAME",
  }
}
